import classNames from "classnames";
import * as React from "react";
import {inject, observer} from "mobx-react";

import {AdBanner} from "@ok/web/components/base/AdBanner/AdBanner";
import {FullScreenBannerHook} from "OK/ads/banner/hook/FullScreenBannerHook";

import {RbAdBannerFullScreenStore} from "../../lib/RbAdBannerFullScreenStore";
import {RbAdBannerFullScreenController} from "../../lib/RbAdBannerFullScreenController";

import css from "./RbAdBannerFullScreen.styl";

export interface IRbAdBannerFullScreenProps {
    store?: RbAdBannerFullScreenStore;
    ctrl?: RbAdBannerFullScreenController;
}

@inject("store", "ctrl")
@observer
export class RbAdBannerFullScreen extends React.Component<IRbAdBannerFullScreenProps> {

    render() {
        const settings = this.props.store?.settings;
        if (!settings || !settings.slot) {
            return;
        }
        return (
            <AdBanner
                bannerHookType={FullScreenBannerHook}
                bannerName={'FullScreen'}
                bannerParams={settings}
                className={classNames(
                    css['box'],
                    {
                        [css['__dark-back']]: settings.boxDarkBack
                    }
                )}
            />
        );
    }
}
